function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { StyledTerminalWrapper, StyledTerminal, StyledTerminalInner, StyledInputWrapper, StyledInput, StyledPrompt, StyledLoadingCursor, StyledBlinkCursor, StyledCommand, StyledLine, StyledHeader, StyledHeaderTitle, StyledHeaderDotList, StyledHeaderDotItem } from './style';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { systemCmdList, tipCmdList } from './commands';
import { setCaretPosition } from './utils';

var Terminal = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(Terminal, _PureComponent);

  function Terminal(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "historyCmdList", []);

    _defineProperty(_assertThisInitialized(_this), "historyCmdIndex", 0);

    _defineProperty(_assertThisInitialized(_this), "run", function (command, inputCommand) {
      if (inputCommand === void 0) {
        inputCommand = _this.state.command;
      }

      var cmd = _this.props.cmd;

      _this.setState({
        isPrinting: true
      });

      return cmd.dynamicList[command].run(_this.print, inputCommand).then(_this.print)["catch"](function (error) {
        console.error(error);

        _this.print(tipCmdList.error);
      })["finally"](function () {
        _this.setState({
          isPrinting: false
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "print", function (cmd) {
      _this.setState(function (prevState) {
        return {
          cmdList: [].concat(prevState.cmdList, Array.isArray(cmd) ? cmd : [cmd])
        };
      });

      _this.autoScroll();
    });

    _defineProperty(_assertThisInitialized(_this), "inputFocus", function () {
      _this.$inputEl.current.focus();
    });

    _defineProperty(_assertThisInitialized(_this), "autoScroll", function () {
      _this.$terminal.current.scrollTop = _this.$inputWrapper.current.offsetTop;
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyCommand", function (e) {
      var prompt = _this.props.config.prompt;
      var isDownKey = e.keyCode === 40;
      var isUpKey = e.keyCode === 38;
      var isTabKey = e.keyCode === 9;
      var isCKey = e.keyCode === 67;
      var isDKey = e.keyCode === 68;
      var isLKey = e.keyCode === 76;
      var isCtrlCKey = isCKey && e.ctrlKey && !e.shiftKey;
      var isCtrlDKey = isDKey && e.ctrlKey && !e.shiftKey;
      var isCtrlLKey = isLKey && e.ctrlKey && !e.shiftKey;

      if (isDownKey) {
        _this.historyCmdIndex = Math.min(_this.historyCmdIndex + 1, _this.historyCmdList.length - 1);
      } else if (isUpKey) {
        _this.historyCmdIndex = Math.max(_this.historyCmdIndex - 1, 0);
      }

      if (isUpKey || isDownKey) {
        var historyCmd = _this.historyCmdList[_this.historyCmdIndex];

        if (historyCmd) {
          _this.setState({
            command: historyCmd
          });

          setTimeout(function () {
            setCaretPosition(_this.$inputEl.current, historyCmd.length + 1);
          }, 0);
        }
      }

      var _this$state = _this.state,
          command = _this$state.command,
          isPrinting = _this$state.isPrinting;

      if (isPrinting) {
        return;
      }

      if (isTabKey) {
        if (!command) {
          _this.setState({
            command: 'help'
          });
        }

        var canExtendCmdList = _this.allCmdList.filter(function (c) {
          return c.startsWith(command);
        });

        if (canExtendCmdList && canExtendCmdList.length) {
          _this.setState({
            command: canExtendCmdList[Math.floor(Math.random() * canExtendCmdList.length)]
          });
        }

        e.preventDefault();
      }

      if (isCtrlCKey) {
        _this.print("" + prompt + command);

        _this.setState({
          command: ''
        });

        e.preventDefault();
      }

      if (isCtrlDKey) {
        _this.print(tipCmdList.jump);

        e.preventDefault();
        window.history.go(-1);
      }

      if (isCtrlLKey) {
        _this.setState({
          cmdList: []
        });

        e.preventDefault();
      }

      _this.autoScroll();

      _this.inputFocus();
    });

    _defineProperty(_assertThisInitialized(_this), "handleCommand", function (e) {
      var _this$props = _this.props,
          cmd = _this$props.cmd,
          _this$props$config = _this$props.config,
          prompt = _this$props$config.prompt,
          versionNumber = _this$props$config.version;
      var isEnterKey = e.keyCode === 13;

      if (!isEnterKey) {
        _this.handleKeyCommand(e);

        return;
      }

      if (!_this.state.command) {
        _this.print(prompt);

        return;
      }

      var command = _this.state.command.toLowerCase().trim();

      _this.historyCmdList.push(command);

      _this.historyCmdIndex = _this.historyCmdList.length;

      _this.print("" + prompt + command);

      var cmdList = [];

      var _command$split = command.split(' '),
          action = _command$split[0],
          commandKey = _command$split[1];

      var isStaticCommand = !!cmd.staticList[command];
      var isDynamicCommand = !!cmd.dynamicList[action];
      var exit = systemCmdList.exit,
          help = systemCmdList.help,
          clear = systemCmdList.clear,
          pwd = systemCmdList.pwd,
          cd = systemCmdList.cd,
          version = systemCmdList.version;
      var unknown = tipCmdList.unknown,
          jump = tipCmdList.jump,
          supporting = tipCmdList.supporting;

      if (exit.aliasList.includes(action)) {
        cmdList.push(jump);

        _this.print(cmdList);

        window.history.go(-1);
      } else if (help.aliasList.includes(action)) {
        if (commandKey) {
          var _command = cmd.staticList[commandKey] || cmd.dynamicList[commandKey];

          cmdList.push(_command.description);

          _this.print(cmdList);
        } else {
          cmdList.push(supporting);

          var supportedCmdList = _this.supportedCmdList.map(function (commandKey) {
            var command = cmd.staticList[commandKey] || cmd.dynamicList[commandKey];
            return {
              type: 'success',
              label: commandKey,
              content: "() => " + command.description
            };
          });

          cmdList.push.apply(cmdList, supportedCmdList);
          cmdList.push(clear, exit);

          _this.print(cmdList);
        }
      } else if (clear.aliasList.includes(action)) {
        _this.setState({
          cmdList: []
        });
      } else if (pwd.aliasList.includes(action)) {
        _this.print(_this.state.directory);
      } else if (cd.aliasList.includes(action)) {
        if (commandKey) {
          var directory = commandKey.trim();

          if (directory && directory.length < 20) {
            _this.setState({
              directory: directory
            });
          }
        }
      } else if (version.aliasList.includes(action)) {
        _this.print(versionNumber);
      } else if (isStaticCommand) {
        _this.print(cmd.staticList[command].list);
      } else if (isDynamicCommand) {
        _this.run(action, commandKey);
      } else if (action.trim()) {
        unknown.content = unknown.contentWithCommand(action);

        _this.print([unknown, help]);
      }

      _this.setState({
        command: ''
      });

      setTimeout(_this.autoScroll, 0);

      _this.inputFocus();
    });

    _this.$terminal = React.createRef();
    _this.$inputWrapper = React.createRef();
    _this.$inputEl = React.createRef();
    var config = props.config,
        _cmd = props.cmd;
    _this.state = {
      cmdList: [],
      command: '',
      directory: config.initialDirectory,
      isPrinting: true
    };
    _this.supportedCmdList = [].concat(Object.keys(_cmd.staticList), Object.keys(_cmd.dynamicList));
    _this.allCmdList = [].concat(_this.supportedCmdList, Object.keys(systemCmdList).map(function (key) {
      return systemCmdList[key].aliasList;
    }).flat(1));
    return _this;
  }

  var _proto = Terminal.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var bootCmd = this.props.config.bootCmd;
    this.run(bootCmd).then(function () {
      var help = systemCmdList.help,
          clear = systemCmdList.clear,
          exit = systemCmdList.exit;

      _this2.print([help, clear, exit]);

      _this2.inputFocus();
    });
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$props2 = this.props,
        className = _this$props2.className,
        prompt = _this$props2.config.prompt;
    var _this$state2 = this.state,
        cmdList = _this$state2.cmdList,
        isPrinting = _this$state2.isPrinting,
        command = _this$state2.command,
        directory = _this$state2.directory;
    return /*#__PURE__*/React.createElement(StyledTerminalWrapper, {
      className: className
    }, /*#__PURE__*/React.createElement(StyledHeader, null, /*#__PURE__*/React.createElement(StyledHeaderTitle, null, directory), /*#__PURE__*/React.createElement(StyledHeaderDotList, null, /*#__PURE__*/React.createElement(StyledHeaderDotItem, {
      color: "red"
    }), /*#__PURE__*/React.createElement(StyledHeaderDotItem, {
      color: "yellow"
    }), /*#__PURE__*/React.createElement(StyledHeaderDotItem, {
      color: "green"
    }))), /*#__PURE__*/React.createElement(StyledTerminal, {
      ref: this.$terminal
    }, /*#__PURE__*/React.createElement(StyledTerminalInner, {
      onClick: this.inputFocus
    }, /*#__PURE__*/React.createElement(TransitionGroup, null, cmdList.map(function (item, index) {
      return /*#__PURE__*/React.createElement(CSSTransition, {
        key: index,
        timeout: 500
      }, /*#__PURE__*/React.createElement(StyledLine, null, typeof item === 'string' ? /*#__PURE__*/React.createElement(StyledCommand, {
        className: "cmd"
      }, item) : /*#__PURE__*/React.createElement(React.Fragment, null, item.time && /*#__PURE__*/React.createElement(StyledCommand, {
        className: "time"
      }, item.time), item.label && /*#__PURE__*/React.createElement(StyledCommand, {
        className: item.type
      }, item.label), item.content && /*#__PURE__*/React.createElement(StyledCommand, {
        className: "cmd"
      }, item.content))));
    })), /*#__PURE__*/React.createElement(StyledInputWrapper, {
      ref: this.$inputWrapper,
      onClick: this.inputFocus
    }, isPrinting ? /*#__PURE__*/React.createElement(StyledLoadingCursor, null, ".") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledPrompt, null, prompt), /*#__PURE__*/React.createElement(StyledCommand, null, command), /*#__PURE__*/React.createElement(StyledBlinkCursor, null, "\xA0")), /*#__PURE__*/React.createElement(StyledInput, {
      value: command,
      onChange: function onChange(e) {
        _this3.setState({
          command: e.target.value
        });
      },
      onKeyDown: this.handleCommand,
      autoFocus: true,
      ref: this.$inputEl
    })))));
  };

  return Terminal;
}(PureComponent);

_defineProperty(Terminal, "defaultProps", {
  className: 'react-terimnal-app',
  config: {
    initialDirectory: 'src',
    prompt: '➜  ~ ',
    version: '1.0.0',
    bootCmd: 'intro'
  }
});

Terminal.propTypes = process.env.NODE_ENV !== "production" ? {
  cmd: PropTypes.shape({
    dynamicList: PropTypes.object,
    staticList: PropTypes.object
  }).isRequired,
  config: PropTypes.shape({
    initialDirectory: PropTypes.string,
    prompt: PropTypes.string,
    version: PropTypes.string,
    bootCmd: PropTypes.string
  }),
  className: PropTypes.string
} : {};
export default Terminal;